module.exports = __webpack_public_path__ + "static/media/4ODA1.4ba227b1.jpg";